import { Check, Pencil, X } from "lucide-react";
import type { BulkEditRow as BulkEditRowType } from "@netsuite-ai/types";
import Modal from "../../Modal";

interface Props {
  row: BulkEditRowType;
  onApprove: () => void;
  onDeny: () => void;
}

export function BulkEditRow({ row, onApprove, onDeny }: Props) {
  const entries = Object.entries(row.fields);
  const primary = `${String(entries[0]?.[1] ?? "")} · ${row.id}`;
  const secondary = String(entries[1]?.[1] ?? "");

  const isApproved = row.status === "approved";

  return (
    <div className="flex items-center justify-between px-4 py-3 transition-colors">
      <div className="min-w-0 flex-1">
        <p className="truncate text-sm font-medium text-neutral-900">{primary}</p>
        <p className="text-sm text-neutral-500">{secondary}</p>
      </div>

      <div className="ml-3 flex shrink-0 items-center gap-1">
        <button
          onClick={(e) => { e.stopPropagation(); onApprove(); }}
          className={[
            "rounded border p-1.5 transition-colors",
            isApproved
              ? "border-green-500 bg-green-50 text-green-600 dark:border-green-600 dark:bg-green-950/40 dark:text-green-300"
              : "border-neutral-300 bg-white text-neutral-600 hover:border-green-400 hover:text-green-600 dark:hover:border-green-500 dark:hover:text-green-400",
          ].join(" ")}
        >
          <Check size={13} />
        </button>

        <Modal.Open opens={row.id}>
          <button
            onClick={(e) => e.stopPropagation()}
            className="rounded border border-neutral-300 bg-white p-1.5 text-neutral-600 transition-colors hover:border-neutral-500 hover:text-neutral-900"
          >
            <Pencil size={13} />
          </button>
        </Modal.Open>

        <button
          onClick={(e) => { e.stopPropagation(); onDeny(); }}
          className="rounded border border-red-500 bg-danger p-1.5 text-white transition-colors hover:bg-red-700"
        >
          <X size={13} />
        </button>
      </div>
    </div>
  );
}
